module.exports = __webpack_public_path__ + "img/southampton-logo-icon.00c39b63.png";